module.exports = __webpack_public_path__ + "static/media/fb_icon.9a78bbee.svg";